// Bình luận chỉ toàn emoji (kiểu Messenger) → render emoji to hơn cho dễ nhìn.
// True nếu bỏ hết emoji + modifier + ZWJ (200D) + variation-selector (FE0F) + skin tone + whitespace mà không còn ký tự nào.
export const isEmojiOnly = (text?: string | null): boolean => {
  if (!text) return false;
  const t = text.trim();
  if (!t) return false;
  const rest = t.replace(
    /[\p{Extended_Pictographic}\p{Emoji_Modifier}‍️\u{1F3FB}-\u{1F3FF}\s]/gu,
    ''
  );
  return rest.length === 0;
};

/** className cho <p> nội dung: emoji-only → chữ to; ngược lại trả '' (giữ nguyên). */
export const emojiOnlyTextClass = (text?: string | null): string =>
  isEmojiOnly(text) ? 'text-[30px] leading-tight' : '';
